import { render, staticRenderFns } from "./FollowUpConfirm.vue?vue&type=template&id=7b467571&scoped=true&"
import script from "./FollowUpConfirm.vue?vue&type=script&lang=js&"
export * from "./FollowUpConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b467571",
  null
  
)

export default component.exports